import { render, staticRenderFns } from "./EditTrade2.vue?vue&type=template&id=397655a0&scoped=true"
import script from "./EditTrade2.vue?vue&type=script&lang=js"
export * from "./EditTrade2.vue?vue&type=script&lang=js"
import style0 from "./EditTrade2.vue?vue&type=style&index=0&id=397655a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397655a0",
  null
  
)

export default component.exports